<script setup lang="ts">
  import IconImage from '@/shared/ui/common/IconImage.vue';

  const props = withDefaults(
    defineProps<{
      options: { id: string; text: string; icon?: string; badge?: string }[];
      selectedOption: string;
      visualVariant?: 'default' | 'neutral';
      mutedInactiveText?: boolean;
    }>(),
    {
      visualVariant: 'default',
      mutedInactiveText: false,
    }
  );

  const emit = defineEmits<{ 'option-selected': [optionId: string] }>();

  const handleOptionSelect = (optionId: string) => {
    emit('option-selected', optionId);
  };

  const tabButtonClass = (optionId: string) => {
    const selected = props.selectedOption === optionId;
    if (selected) {
      return 'bg-white-01 rounded-lg shadow-sm text-gray-07';
    }
    if (props.visualVariant === 'neutral') {
      return props.mutedInactiveText ? 'rounded-lg hover:text-gray-07' : 'text-gray-07 rounded-lg';
    }
    return '';
  };
</script>

<template>
  <button
    v-for="option in props.options"
    type="button"
    :data-testid="option.id"
    class="px-4 py-1.5 flex gap-3 items-center cursor-pointer"
    :class="tabButtonClass(option.id)"
    @click="handleOptionSelect(option.id)"
  >
    <IconImage
      v-if="option.icon"
      :src="option.icon"
      :alt="option.text"
    />
    <span>{{ option.text }}</span>
    <span
      v-if="option.badge"
      class="px-2 py-0.5 text-sm font-medium rounded-full text-gray-07"
      :class="selectedOption === option.id ? 'bg-gray-02' : 'bg-white-01'"
    >
      {{ option.badge }}
    </span>
  </button>
</template>
